const fiveOneSchema = {
  title: "5_1 Use Stage of the Product",
  addAPI: "cat5_1AddEmissionActivityAPI",
  cat: "cat5_1",
  EATitle: "Emission Activity",
  fields: [
    {
      key: "itemName",
      level: 1,
      type: "input",
      label: "Name / Number",
      resetOnChange: false,
      required: true,
    },
    //////// Activity Type
    {
      key: "activityId",
      level: 1,
      type: "select",
      label: "Activity Type",
      optionsAPI: "cat5_1EADropdownAPI",
      required: true,
    },
  ],
};
export default fiveOneSchema;
